import { inject } from '@angular/core';
import { HttpHandlerFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError, finalize, throwError } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { CoreService } from '../services/core.service';
import { Router } from '@angular/router';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const loaderService = inject(LoaderService);
  const coreService = inject(CoreService);
  const router = inject(Router);

  loaderService.show();

  // Get token inside the function to ensure we have the latest value
  const storageUser = localStorage.getItem('userInfo');
  const token = storageUser ? JSON.parse(storageUser).token : '';
  
  // Only add the Publio token when the request has no explicit authorization.
  const usesPublioToken = Boolean(token) && !req.headers.has('Authorization');

  let newReq = req;
  if (usesPublioToken) {
    newReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
  }

  return next(newReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && usesPublioToken) {
        localStorage.removeItem('userInfo');
        router.navigate(['/login']);
      }

      console.log('Error:', error);

      const backend = error.error || {};
      const message = backend.message || 'An error occurred';
      coreService.showSnackbar(message);

      return throwError(() => error);
    }),
    finalize(() => {
      loaderService.hide();
    })
  );
}
